export const EditReservation = async (reservationId, updatedData) => {
    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;

    try {
        const response = await fetch(`${apiUrl}/api/reservations/${reservationId}/update`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(updatedData),
        });

        console.log("response api", response);

        if (!response.ok) {
            throw new Error('Failed to update reservation');
        }

        return await response.json(); // Return the response body (if needed)
    } catch (error) {
        console.error("API error:", error);
        throw error; // Re-throw the error to be caught in the calling function
    }
};
